import { useState, useEffect } from 'react';
import { supabase } from '../../supabase';

function AdsLancamento({ cliente, setPaginaAtiva }) {
  const [canais, setCanais] = useState([]);
  const [colunas, setColunas] = useState({});
  const [lancamentos, setLancamentos] = useState({});
  const [semanaAtual, setSemanaAtual] = useState(0);
  const [carregando, setCarregando] = useState(true);
  const [salvando, setSalvando] = useState(false);
  const [canalFiltro, setCanalFiltro] = useState('todos');
  const [celulaEditando, setCelulaEditando] = useState(null);
  const [menuAgregacao, setMenuAgregacao] = useState(null);
  const [modalNovoCanal, setModalNovoCanal] = useState(false);
  const [modalNovaColuna, setModalNovaColuna] = useState(null);
  const [modalEditarColuna, setModalEditarColuna] = useState(null);
  const [modalEditarCanal, setModalEditarCanal] = useState(null);
  const [novoCanal, setNovoCanal] = useState({ nome: '', cor: '#378ADD' });
  const [novaColuna, setNovaColuna] = useState({ nome: '', tipo: 'numero', agregacao: 'soma' });

  const tipos = [
    { val: 'moeda', label: 'Moeda (R$)' },
    { val: 'numero', label: 'Número' },
    { val: 'percentual', label: 'Percentual (%)' },
    { val: 'multiplicador', label: 'Multiplicador (x)' },
  ];

  useEffect(() => {
    if (cliente) carregarTudo();
  }, [cliente, semanaAtual]);

  const getDatasSemana = (offset = 0) => {
    const hoje = new Date();
    const diaSemana = hoje.getDay();
    const diasParaSegunda = diaSemana === 0 ? -6 : 1 - diaSemana;
    const inicioSemana = new Date(hoje);
    inicioSemana.setDate(hoje.getDate() + diasParaSegunda + (offset * 7));
    const datas = [];
    for (let i = 0; i < 7; i++) {
      const d = new Date(inicioSemana);
      d.setDate(inicioSemana.getDate() + i);
      datas.push(d);
    }
    return datas;
  };

  const formatarDataKey = (date) => date.toISOString().split('T')[0];
  const formatarDataLabel = (date) => {
    const dias = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];
    return { dia: date.getDate(), semana: dias[date.getDay()], key: formatarDataKey(date) };
  };

  const carregarTudo = async () => {
    const datas = getDatasSemana(semanaAtual);
    const inicio = formatarDataKey(datas[0]);
    const fim = formatarDataKey(datas[6]);
    const [{ data: canaisData }, { data: colunasData }, { data: lancsData }] = await Promise.all([
      supabase.from('ads_canais_cliente').select('*').eq('cliente_id', cliente.id).eq('ativo', true).order('ordem'),
      supabase.from('ads_colunas_canal').select('*').eq('cliente_id', cliente.id).order('ordem'),
      supabase.from('ads_lancamentos').select('*').eq('cliente_id', cliente.id).gte('data_ref', inicio).lte('data_ref', fim),
    ]);
    setCanais(canaisData || []);
    const colMap = {};
    (colunasData || []).forEach(c => {
      if (!colMap[c.canal_id]) colMap[c.canal_id] = [];
      colMap[c.canal_id].push(c);
    });
    setColunas(colMap);
    const lanMap = {};
    (lancsData || []).forEach(l => { lanMap[`${l.data_ref}_${l.canal}`] = l.valores || {}; });
    setLancamentos(lanMap);
    setCarregando(false);
  };

  const handleEdit = (dataKey, canalNome, colunaNome, valor) => {
    const key = `${dataKey}_${canalNome}`;
    setLancamentos(prev => ({ ...prev, [key]: { ...(prev[key] || {}), [colunaNome]: valor } }));
  };

  const salvarLancamento = async (dataKey, canalNome) => {
    const key = `${dataKey}_${canalNome}`;
    const valores = lancamentos[key] || {};
    console.log('Salvando:', { dataKey, canalNome, valores, clienteId: cliente.id });
    setSalvando(true);
    const { data, error } = await supabase.from('ads_lancamentos').upsert({
      cliente_id: cliente.id,
      data_ref: dataKey,
      canal: canalNome,
      valores,
    }, { onConflict: 'cliente_id,data_ref,canal' });
    console.log('Resultado:', { data, error });
    setSalvando(false);
    setCelulaEditando(null);
  };

  const criarCanal = async () => {
    if (!novoCanal.nome.trim()) return;
    await supabase.from('ads_canais_cliente').insert({ cliente_id: cliente.id, nome: novoCanal.nome.trim(), cor: novoCanal.cor, ordem: canais.length });
    setNovoCanal({ nome: '', cor: '#378ADD' });
    setModalNovoCanal(false);
    carregarTudo();
  };

  const editarCanal = async () => {
    if (!modalEditarCanal?.nome.trim()) return;
    await supabase.from('ads_canais_cliente').update({ nome: modalEditarCanal.nome, cor: modalEditarCanal.cor }).eq('id', modalEditarCanal.id);
    setModalEditarCanal(null);
    carregarTudo();
  };

  const deletarCanal = async (canalId) => {
    if (!window.confirm('Deletar este canal e todos os dados lançados nele?')) return;
    await supabase.from('ads_canais_cliente').delete().eq('id', canalId);
    carregarTudo();
  };

  const criarColuna = async (canalId) => {
    if (!novaColuna.nome.trim()) return;
    await supabase.from('ads_colunas_canal').insert({
      canal_id: canalId, cliente_id: cliente.id, nome: novaColuna.nome.trim(),
      tipo: novaColuna.tipo, agregacao: novaColuna.agregacao, ordem: (colunas[canalId] || []).length,
    });
    setNovaColuna({ nome: '', tipo: 'numero', agregacao: 'soma' });
    setModalNovaColuna(null);
    carregarTudo();
  };

  const editarColuna = async () => {
    if (!modalEditarColuna?.nome.trim()) return;
    await supabase.from('ads_colunas_canal').update({ nome: modalEditarColuna.nome, tipo: modalEditarColuna.tipo, agregacao: modalEditarColuna.agregacao }).eq('id', modalEditarColuna.id);
    setModalEditarColuna(null);
    carregarTudo();
  };

  const deletarColuna = async (coluna) => {
    if (!window.confirm(`Deletar coluna "${coluna.nome}" e todos os dados?`)) return;
    await supabase.rpc('deletar_coluna_ads', { p_coluna_id: coluna.id, p_nome_coluna: coluna.nome, p_cliente_id: cliente.id });
    carregarTudo();
  };

  const toggleFavorita = async (coluna) => {
    await supabase.from('ads_colunas_canal').update({ favorita: !coluna.favorita }).eq('id', coluna.id);
    carregarTudo();
  };

  const atualizarAgregacao = async (coluna, novaAgregacao) => {
    await supabase.from('ads_colunas_canal').update({ agregacao: novaAgregacao }).eq('id', coluna.id);
    setMenuAgregacao(null);
    carregarTudo();
  };

  const calcularAgregado = (canalNome, coluna) => {
    const datas = getDatasSemana(semanaAtual);
    const valores = [];
    datas.forEach(d => {
      const val = lancamentos[`${formatarDataKey(d)}_${canalNome}`]?.[coluna.nome];
      if (val) valores.push(Number(val));
    });
    if (!valores.length) return '—';
    const resultado = coluna.agregacao === 'media'
      ? valores.reduce((a, b) => a + b, 0) / valores.length
      : valores.reduce((a, b) => a + b, 0);
    return formatarDisplay(resultado, coluna.tipo);
  };

  const formatarDisplay = (val, tipo) => {
    if (!val && val !== 0) return null;
    const n = Number(val);
    if (tipo === 'moeda') return `R$ ${n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    if (tipo === 'percentual') return `${n.toFixed(1)}%`;
    if (tipo === 'multiplicador') return `${n.toFixed(2)}x`;
    return n % 1 === 0 ? n.toLocaleString('pt-BR') : n.toFixed(2);
  };

  const isHoje = (date) => formatarDataKey(date) === formatarDataKey(new Date());
  const isFuturo = (date) => { const h = new Date(); h.setHours(0,0,0,0); return date > h; };

  const getLabelSemana = () => {
    const datas = getDatasSemana(semanaAtual);
    const meses = ['jan','fev','mar','abr','mai','jun','jul','ago','set','out','nov','dez'];
    return `${datas[0].getDate()} ${meses[datas[0].getMonth()]} — ${datas[6].getDate()} ${meses[datas[6].getMonth()]}`;
  };

  const datas = getDatasSemana(semanaAtual);
  const canaisExibir = canalFiltro === 'todos' ? canais : canais.filter(c => c.id === canalFiltro);

  if (!cliente) return null;
  if (carregando) return <div className="flex items-center justify-center h-64"><p style={{ color: '#555' }}>Carregando...</p></div>;

  const CORES = ['#378ADD','#22c55e','#f59e0b','#ef4444','#c084fc','#DCF127','#06b6d4','#f97316'];

  return (
    <div>
      <style>{`
        input[type=number]::-webkit-inner-spin-button,
        input[type=number]::-webkit-outer-spin-button { -webkit-appearance: none; margin: 0; }
        input[type=number] { -moz-appearance: textfield; }
      `}</style>

      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <button onClick={() => setPaginaAtiva('ads')} className="text-sm" style={{ color: '#555' }}
            onMouseEnter={(e) => e.currentTarget.style.color = '#fff'}
            onMouseLeave={(e) => e.currentTarget.style.color = '#555'}>← Ads</button>
          <span style={{ color: '#333' }}>/</span>
          <h1 className="text-xl font-bold text-white">{cliente.nome}</h1>
          <span style={{ color: '#333' }}>/</span>
          <span className="text-sm" style={{ color: '#555' }}>Lançamento diário</span>
          {salvando && <span className="text-xs" style={{ color: '#555' }}>salvando...</span>}
        </div>
        <button onClick={() => setModalNovoCanal(true)}
          className="text-xs px-3 py-2 rounded-lg"
          style={{ backgroundColor: '#DCF127', color: '#0a0a0a', fontWeight: 500 }}>
          + Novo canal
        </button>
      </div>

      {/* Filtros + semana */}
      <div className="flex items-center justify-between mb-4">
        <div className="flex gap-2 flex-wrap">
          <button onClick={() => setCanalFiltro('todos')}
            className="text-xs px-4 py-1.5 rounded-full transition-all"
            style={{
              backgroundColor: canalFiltro === 'todos' ? '#DCF127' : '#111',
              color: canalFiltro === 'todos' ? '#0a0a0a' : '#666',
              border: canalFiltro === 'todos' ? 'none' : '1px solid #1a1a1a',
            }}>Todos</button>
          {canais.map(c => (
            <button key={c.id} onClick={() => setCanalFiltro(c.id)}
              className="text-xs px-4 py-1.5 rounded-full transition-all"
              style={{
                backgroundColor: canalFiltro === c.id ? c.cor : '#111',
                color: canalFiltro === c.id ? '#fff' : '#666',
                border: canalFiltro === c.id ? 'none' : '1px solid #1a1a1a',
              }}>{c.nome}</button>
          ))}
        </div>
        <div className="flex items-center gap-3">
          <button onClick={() => setSemanaAtual(s => s - 1)}
            className="w-8 h-8 rounded-lg flex items-center justify-center"
            style={{ backgroundColor: '#111', border: '1px solid #1a1a1a', color: '#aaa' }}>‹</button>
          <span className="text-sm font-medium text-white">{getLabelSemana()}</span>
          <button onClick={() => setSemanaAtual(s => s + 1)}
            className="w-8 h-8 rounded-lg flex items-center justify-center"
            style={{ backgroundColor: '#111', border: '1px solid #1a1a1a', color: '#aaa' }}>›</button>
        </div>
      </div>

      {/* Sem canais */}
      {canais.length === 0 && (
        <div className="rounded-xl p-8 text-center" style={{ backgroundColor: '#111', border: '1px solid #1a1a1a' }}>
          <p style={{ color: '#555' }}>Nenhum canal configurado.</p>
          <button onClick={() => setModalNovoCanal(true)}
            className="text-xs px-4 py-2 rounded-lg mt-3 font-medium"
            style={{ backgroundColor: '#DCF127', color: '#0a0a0a' }}>+ Criar primeiro canal</button>
        </div>
      )}

      {/* Consolidado */}
      {canalFiltro === 'todos' && canais.length > 0 && (() => {
        const todasColunas = [];
        const nomesVistos = new Set();
        canais.forEach(canal => {
          (colunas[canal.id] || []).forEach(col => {
            if (!nomesVistos.has(col.nome)) { nomesVistos.add(col.nome); todasColunas.push(col); }
          });
        });
        if (!todasColunas.length) return null;

        const calcularConsolidado = (coluna) => {
          const datas = getDatasSemana(semanaAtual);
          const valores = [];
          canais.forEach(canal => {
            datas.forEach(d => {
              const val = lancamentos[`${formatarDataKey(d)}_${canal.nome}`]?.[coluna.nome];
              if (val) valores.push(Number(val));
            });
          });
          if (!valores.length) return '—';
          const resultado = coluna.agregacao === 'media'
            ? valores.reduce((a, b) => a + b, 0) / valores.length
            : valores.reduce((a, b) => a + b, 0);
          return formatarDisplay(resultado, coluna.tipo);
        };

        return (
          <div className="mb-6">
            <div className="flex items-center gap-2 mb-2">
              <span className="text-sm font-semibold text-white">Consolidado</span>
              <span className="text-xs px-2 py-0.5 rounded-full" style={{ backgroundColor: '#1a1a1a', color: '#555' }}>todos os canais · semana</span>
            </div>
            <div className="rounded-xl overflow-hidden" style={{ border: '1px solid #1a1a1a' }}>
              <table className="w-full" style={{ borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ backgroundColor: '#111' }}>
                    {todasColunas.map(col => (
                      <th key={col.id} className="text-right px-4 py-3 text-xs font-medium" style={{ color: '#555', minWidth: '140px', borderBottom: '1px solid #1a1a1a' }}>
                        {col.nome}
                        <span className="ml-1 text-xs" style={{ color: '#333' }}>{col.agregacao === 'media' ? 'média' : 'soma'}</span>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  <tr style={{ backgroundColor: '#111' }}>
                    {todasColunas.map(col => (
                      <td key={col.nome} className="px-4 py-4 text-right">
                        <span className="text-lg font-semibold text-white">{calcularConsolidado(col)}</span>
                      </td>
                    ))}
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        );
      })()}

      {/* Tabelas por canal */}
      {canaisExibir.map(canal => {
        const colunasCanal = colunas[canal.id] || [];
        return (
          <div key={canal.id} className="mb-6">
            <div className="flex items-center gap-3 mb-2">
              <div className="w-3 h-3 rounded-full" style={{ backgroundColor: canal.cor }} />
              <span className="text-sm font-semibold text-white">{canal.nome}</span>
              <button onClick={() => setModalEditarCanal({ ...canal })} style={{ color: '#333', background: 'none', border: 'none', cursor: 'pointer', fontSize: '13px' }}
                onMouseEnter={(e) => e.currentTarget.style.color = '#aaa'}
                onMouseLeave={(e) => e.currentTarget.style.color = '#333'}>✎</button>
              <button onClick={() => deletarCanal(canal.id)} style={{ color: '#333', background: 'none', border: 'none', cursor: 'pointer', fontSize: '13px' }}
                onMouseEnter={(e) => e.currentTarget.style.color = '#ef4444'}
                onMouseLeave={(e) => e.currentTarget.style.color = '#333'}>✕</button>
            </div>
            <div className="rounded-xl overflow-hidden" style={{ border: '1px solid #1a1a1a' }}>
              <table className="w-full" style={{ borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ backgroundColor: '#111' }}>
                    <th className="text-left px-4 py-3 text-xs font-medium" style={{ color: '#555', minWidth: '90px', borderBottom: '1px solid #1a1a1a' }}>Data</th>
                    {colunasCanal.map(col => (
                      <th key={col.id} className="text-right px-3 py-3 text-xs font-medium" style={{ color: '#555', minWidth: '120px', borderBottom: '1px solid #1a1a1a' }}>
                        <div className="flex items-center justify-end gap-1">
                          <button onClick={() => toggleFavorita(col)} style={{ color: col.favorita ? '#DCF127' : '#333', fontSize: '11px', background: 'none', border: 'none', cursor: 'pointer' }}>★</button>
                          <span>{col.nome}</span>
                          <button onClick={() => setModalEditarColuna({ ...col })} style={{ color: '#333', fontSize: '11px', background: 'none', border: 'none', cursor: 'pointer' }}
                            onMouseEnter={(e) => e.currentTarget.style.color = '#aaa'}
                            onMouseLeave={(e) => e.currentTarget.style.color = '#333'}>✎</button>
                          <button onClick={() => deletarColuna(col)} style={{ color: '#333', fontSize: '11px', background: 'none', border: 'none', cursor: 'pointer' }}
                            onMouseEnter={(e) => e.currentTarget.style.color = '#ef4444'}
                            onMouseLeave={(e) => e.currentTarget.style.color = '#333'}>✕</button>
                        </div>
                      </th>
                    ))}
                    <th className="px-3 py-3" style={{ borderBottom: '1px solid #1a1a1a', minWidth: '50px' }}>
                      <button onClick={() => { setNovaColuna({ nome: '', tipo: 'numero', agregacao: 'soma' }); setModalNovaColuna(canal.id); }}
                        className="text-xs px-2 py-1 rounded"
                        style={{ color: '#555', background: 'none', border: '1px dashed #333' }}
                        onMouseEnter={(e) => { e.currentTarget.style.color = '#DCF127'; e.currentTarget.style.borderColor = '#DCF127'; }}
                        onMouseLeave={(e) => { e.currentTarget.style.color = '#555'; e.currentTarget.style.borderColor = '#333'; }}>+</button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {datas.map((data) => {
                    const dataLabel = formatarDataLabel(data);
                    const hoje = isHoje(data);
                    const futuro = isFuturo(data);
                    const key = `${dataLabel.key}_${canal.nome}`;
                    return (
                      <tr key={dataLabel.key} style={{ backgroundColor: hoje ? '#0d1a0d' : 'transparent', opacity: futuro ? 0.4 : 1, borderBottom: '1px solid #1a1a1a' }}>
                        <td className="px-4 py-2.5" style={{ borderRight: '1px solid #1a1a1a' }}>
                          <p className="text-sm font-medium text-white flex items-center gap-2">
                            {dataLabel.dia}
                            {hoje && <span className="text-xs px-1.5 py-0.5 rounded font-medium" style={{ backgroundColor: '#0d2a0d', color: '#22c55e' }}>hoje</span>}
                          </p>
                          <p className="text-xs" style={{ color: '#555' }}>{dataLabel.semana}</p>
                        </td>
                        {colunasCanal.map(col => {
                            const valor = lancamentos[key]?.[col.nome] ?? '';
                            const celulaKey = `${key}_${col.nome}`;
                            const editando = celulaEditando === celulaKey;
                            const display = formatarDisplay(valor, col.tipo);
                            return (
                              <td key={col.id} className="px-2 py-1.5" style={{ textAlign: 'right' }}>
                                {!futuro && editando ? (
                                  <input type="text" value={valor} autoFocus
                                    onChange={(e) => handleEdit(dataLabel.key, canal.nome, col.nome, e.target.value)}
                                    onBlur={() => {
                                      const raw = (lancamentos[`${dataLabel.key}_${canal.nome}`]?.[col.nome] || '').toString();
                                      const limpo = raw.replace(/\./g, '').replace(',', '.');
                                      const numero = parseFloat(limpo);
                                      if (!isNaN(numero)) handleEdit(dataLabel.key, canal.nome, col.nome, numero);
                                      salvarLancamento(dataLabel.key, canal.nome);
                                    }}
                                    onKeyDown={(e) => {
                                      if (e.key === 'Enter') {
                                        const raw = (lancamentos[`${dataLabel.key}_${canal.nome}`]?.[col.nome] || '').toString();
                                        const limpo = raw.replace(/\./g, '').replace(',', '.');
                                        const numero = parseFloat(limpo);
                                        if (!isNaN(numero)) handleEdit(dataLabel.key, canal.nome, col.nome, numero);
                                        salvarLancamento(dataLabel.key, canal.nome);
                                      }
                                    }}
                                    className="w-full text-right text-sm rounded-lg px-2 py-1 outline-none"
                                    style={{ backgroundColor: '#1a1a1a', border: '1px solid #333', color: '#fff' }} />
                                ) : (
                                  <div onClick={() => !futuro && setCelulaEditando(celulaKey)}
                                    style={{ color: display ? '#fff' : 'transparent', cursor: futuro ? 'default' : 'pointer', minHeight: '28px', display: 'flex', alignItems: 'center', justifyContent: 'flex-end', padding: '4px 8px', borderRadius: '8px' }}
                                    onMouseEnter={(e) => { if (!futuro) e.currentTarget.style.backgroundColor = '#1a1a1a'; }}
                                    onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}>
                                    {display || '—'}
                                  </div>
                                )}
                              </td>
                            );
                          })}
                        <td />
                      </tr>
                    );
                  })}
                  {colunasCanal.length > 0 && (
                    <tr style={{ backgroundColor: '#111', borderTop: '1px solid #333' }}>
                      <td className="px-4 py-3 text-xs font-medium" style={{ color: '#555' }}>Total</td>
                      {colunasCanal.map(col => {
                        const chaveMenu = `${canal.id}_${col.id}`;
                        return (
                          <td key={col.id} className="px-3 py-3 text-right" style={{ position: 'relative' }}>
                            <button onClick={() => setMenuAgregacao(menuAgregacao === chaveMenu ? null : chaveMenu)}
                              className="text-sm font-semibold text-white flex items-center gap-1 ml-auto"
                              style={{ cursor: 'pointer', background: 'none', border: 'none' }}>
                              {calcularAgregado(canal.nome, col)}
                              <span style={{ fontSize: '10px', color: '#555' }}>▾</span>
                            </button>
                            {menuAgregacao === chaveMenu && (
                              <div className="absolute right-0 bottom-full mb-1 rounded-lg overflow-hidden z-10"
                                style={{ backgroundColor: '#1a1a1a', border: '1px solid #333', minWidth: '100px' }}>
                                {['soma', 'media'].map(op => (
                                  <button key={op} onClick={() => atualizarAgregacao(col, op)}
                                    className="w-full text-right px-3 py-2 text-xs"
                                    style={{ backgroundColor: col.agregacao === op ? '#DCF127' : 'transparent', color: col.agregacao === op ? '#0a0a0a' : '#aaa', display: 'block' }}>
                                    {op === 'soma' ? 'Soma' : 'Média'}
                                  </button>
                                ))}
                              </div>
                            )}
                          </td>
                        );
                      })}
                      <td />
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        );
      })}

      {/* Modal novo canal */}
      {modalNovoCanal && (
        <div className="fixed inset-0 flex items-center justify-center z-50" style={{ backgroundColor: 'rgba(0,0,0,0.7)' }} onClick={() => setModalNovoCanal(false)}>
          <div className="rounded-2xl p-6 w-full max-w-sm" style={{ backgroundColor: '#111', border: '1px solid #333' }} onClick={e => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-base font-semibold text-white">Novo canal</h2>
              <button onClick={() => setModalNovoCanal(false)} style={{ color: '#555' }}>✕</button>
            </div>
            <div className="flex flex-col gap-3 mb-4">
              <div>
                <label className="text-xs mb-1 block" style={{ color: '#555' }}>Nome</label>
                <input type="text" value={novoCanal.nome} onChange={(e) => setNovoCanal({ ...novoCanal, nome: e.target.value })}
                  onKeyDown={(e) => e.key === 'Enter' && criarCanal()} placeholder="Ex: Meta Ads, Google, Analytics..."
                  className="w-full text-sm px-3 py-2 rounded-lg outline-none text-white" style={{ backgroundColor: '#1a1a1a', border: '1px solid #333' }} autoFocus />
              </div>
              <div>
                <label className="text-xs mb-1 block" style={{ color: '#555' }}>Cor</label>
                <div className="flex gap-2 flex-wrap">
                  {CORES.map(cor => (
                    <button key={cor} onClick={() => setNovoCanal({ ...novoCanal, cor })}
                      className="w-7 h-7 rounded-full" style={{ backgroundColor: cor, border: novoCanal.cor === cor ? '2px solid #fff' : '2px solid transparent' }} />
                  ))}
                </div>
              </div>
            </div>
            <div className="flex gap-2">
              <button onClick={() => setModalNovoCanal(false)} className="flex-1 py-2 rounded-lg text-sm" style={{ backgroundColor: '#1a1a1a', color: '#aaa' }}>Cancelar</button>
              <button onClick={criarCanal} className="flex-1 py-2 rounded-lg text-sm font-medium" style={{ backgroundColor: '#DCF127', color: '#0a0a0a' }}>Criar</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal editar canal */}
      {modalEditarCanal && (
        <div className="fixed inset-0 flex items-center justify-center z-50" style={{ backgroundColor: 'rgba(0,0,0,0.7)' }} onClick={() => setModalEditarCanal(null)}>
          <div className="rounded-2xl p-6 w-full max-w-sm" style={{ backgroundColor: '#111', border: '1px solid #333' }} onClick={e => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-base font-semibold text-white">Editar canal</h2>
              <button onClick={() => setModalEditarCanal(null)} style={{ color: '#555' }}>✕</button>
            </div>
            <div className="flex flex-col gap-3 mb-4">
              <div>
                <label className="text-xs mb-1 block" style={{ color: '#555' }}>Nome</label>
                <input type="text" value={modalEditarCanal.nome} onChange={(e) => setModalEditarCanal({ ...modalEditarCanal, nome: e.target.value })}
                  className="w-full text-sm px-3 py-2 rounded-lg outline-none text-white" style={{ backgroundColor: '#1a1a1a', border: '1px solid #333' }} autoFocus />
              </div>
              <div>
                <label className="text-xs mb-1 block" style={{ color: '#555' }}>Cor</label>
                <div className="flex gap-2 flex-wrap">
                  {CORES.map(cor => (
                    <button key={cor} onClick={() => setModalEditarCanal({ ...modalEditarCanal, cor })}
                      className="w-7 h-7 rounded-full" style={{ backgroundColor: cor, border: modalEditarCanal.cor === cor ? '2px solid #fff' : '2px solid transparent' }} />
                  ))}
                </div>
              </div>
            </div>
            <div className="flex gap-2">
              <button onClick={() => setModalEditarCanal(null)} className="flex-1 py-2 rounded-lg text-sm" style={{ backgroundColor: '#1a1a1a', color: '#aaa' }}>Cancelar</button>
              <button onClick={editarCanal} className="flex-1 py-2 rounded-lg text-sm font-medium" style={{ backgroundColor: '#DCF127', color: '#0a0a0a' }}>Salvar</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal nova coluna */}
      {modalNovaColuna && (
        <div className="fixed inset-0 flex items-center justify-center z-50" style={{ backgroundColor: 'rgba(0,0,0,0.7)' }} onClick={() => setModalNovaColuna(null)}>
          <div className="rounded-2xl p-6 w-full max-w-sm" style={{ backgroundColor: '#111', border: '1px solid #333' }} onClick={e => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-base font-semibold text-white">Nova coluna</h2>
              <button onClick={() => setModalNovaColuna(null)} style={{ color: '#555' }}>✕</button>
            </div>
            <div className="flex flex-col gap-3 mb-4">
              <div>
                <label className="text-xs mb-1 block" style={{ color: '#555' }}>Nome</label>
                <input type="text" value={novaColuna.nome} onChange={(e) => setNovaColuna({ ...novaColuna, nome: e.target.value })}
                  onKeyDown={(e) => e.key === 'Enter' && criarColuna(modalNovaColuna)} placeholder="Ex: Gasto, CTR, ROAS..."
                  className="w-full text-sm px-3 py-2 rounded-lg outline-none text-white" style={{ backgroundColor: '#1a1a1a', border: '1px solid #333' }} autoFocus />
              </div>
              <div>
                <label className="text-xs mb-1 block" style={{ color: '#555' }}>Tipo</label>
                <select value={novaColuna.tipo} onChange={(e) => setNovaColuna({ ...novaColuna, tipo: e.target.value })}
                  className="w-full text-sm px-3 py-2 rounded-lg outline-none text-white" style={{ backgroundColor: '#1a1a1a', border: '1px solid #333' }}>
                  {tipos.map(t => <option key={t.val} value={t.val}>{t.label}</option>)}
                </select>
              </div>
              <div>
                <label className="text-xs mb-1 block" style={{ color: '#555' }}>Agregação no total</label>
                <div className="flex gap-2">
                  {['soma', 'media'].map(op => (
                    <button key={op} onClick={() => setNovaColuna({ ...novaColuna, agregacao: op })}
                      className="flex-1 py-2 rounded-lg text-xs font-medium"
                      style={{ backgroundColor: novaColuna.agregacao === op ? '#DCF127' : '#1a1a1a', color: novaColuna.agregacao === op ? '#0a0a0a' : '#aaa', border: novaColuna.agregacao === op ? 'none' : '1px solid #333' }}>
                      {op === 'soma' ? 'Soma' : 'Média'}
                    </button>
                  ))}
                </div>
              </div>
            </div>
            <div className="flex gap-2">
              <button onClick={() => setModalNovaColuna(null)} className="flex-1 py-2 rounded-lg text-sm" style={{ backgroundColor: '#1a1a1a', color: '#aaa' }}>Cancelar</button>
              <button onClick={() => criarColuna(modalNovaColuna)} className="flex-1 py-2 rounded-lg text-sm font-medium" style={{ backgroundColor: '#DCF127', color: '#0a0a0a' }}>Criar</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal editar coluna */}
      {modalEditarColuna && (
        <div className="fixed inset-0 flex items-center justify-center z-50" style={{ backgroundColor: 'rgba(0,0,0,0.7)' }} onClick={() => setModalEditarColuna(null)}>
          <div className="rounded-2xl p-6 w-full max-w-sm" style={{ backgroundColor: '#111', border: '1px solid #333' }} onClick={e => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-base font-semibold text-white">Editar coluna</h2>
              <button onClick={() => setModalEditarColuna(null)} style={{ color: '#555' }}>✕</button>
            </div>
            <div className="flex flex-col gap-3 mb-4">
              <div>
                <label className="text-xs mb-1 block" style={{ color: '#555' }}>Nome</label>
                <input type="text" value={modalEditarColuna.nome} onChange={(e) => setModalEditarColuna({ ...modalEditarColuna, nome: e.target.value })}
                  className="w-full text-sm px-3 py-2 rounded-lg outline-none text-white" style={{ backgroundColor: '#1a1a1a', border: '1px solid #333' }} autoFocus />
              </div>
              <div>
                <label className="text-xs mb-1 block" style={{ color: '#555' }}>Tipo</label>
                <select value={modalEditarColuna.tipo} onChange={(e) => setModalEditarColuna({ ...modalEditarColuna, tipo: e.target.value })}
                  className="w-full text-sm px-3 py-2 rounded-lg outline-none text-white" style={{ backgroundColor: '#1a1a1a', border: '1px solid #333' }}>
                  {tipos.map(t => <option key={t.val} value={t.val}>{t.label}</option>)}
                </select>
              </div>
              <div>
                <label className="text-xs mb-1 block" style={{ color: '#555' }}>Agregação</label>
                <div className="flex gap-2">
                  {['soma', 'media'].map(op => (
                    <button key={op} onClick={() => setModalEditarColuna({ ...modalEditarColuna, agregacao: op })}
                      className="flex-1 py-2 rounded-lg text-xs font-medium"
                      style={{ backgroundColor: modalEditarColuna.agregacao === op ? '#DCF127' : '#1a1a1a', color: modalEditarColuna.agregacao === op ? '#0a0a0a' : '#aaa', border: modalEditarColuna.agregacao === op ? 'none' : '1px solid #333' }}>
                      {op === 'soma' ? 'Soma' : 'Média'}
                    </button>
                  ))}
                </div>
              </div>
            </div>
            <div className="flex gap-2">
              <button onClick={() => setModalEditarColuna(null)} className="flex-1 py-2 rounded-lg text-sm" style={{ backgroundColor: '#1a1a1a', color: '#aaa' }}>Cancelar</button>
              <button onClick={editarColuna} className="flex-1 py-2 rounded-lg text-sm font-medium" style={{ backgroundColor: '#DCF127', color: '#0a0a0a' }}>Salvar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AdsLancamento;